module.exports = __webpack_public_path__ + "static/media/baseMeme5.e4e9be86.jpg";